import { Box, Grid, Tab } from "@mui/material"
import React from "react"
import { useTranslation } from "react-i18next"
import { CustomTabs } from "../../components/Forms/CustomTabs"
import TabPanel from "../../components/TabPanel"
import Event from "../../models/Event"
import InfoTab from "./tabs/InfoTab"

export const EventInfoDialog = (props: { event: Event }) => {
    const [value, setValue] = React.useState(0);
    const { t } = useTranslation()

    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const labels = []
    const tabPanel = []

    labels.push(t("Info") + "")
    tabPanel.push(<TabPanel value={value} index={tabPanel.length}><InfoTab event={props.event} /></TabPanel>)

    return (
        <>
            <Box display="none">
                <Grid container>
                    <Grid item xs>
                        <CustomTabs value={value} onChange={handleChange} aria-label="basic tabs example">
                            {labels.map(label => (<Tab key={label} label={label} />))}
                        </CustomTabs>
                    </Grid>
                </Grid>
            </Box>
            {tabPanel.map(tabPanel => tabPanel)}
        </>
    )
}